import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

@Component({
    selector: 'fi-filter-settings-actions',
    templateUrl: './fi-filter-settings-actions.component.html',
    styleUrls: ['./fi-filter-settings-actions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-filter-settings-actions' },
    standalone: false,
})
export class FiFilterSettingsActionsComponent {
    @Input() currentFilterId: number | string;
    @Input() isClearButtonVisible: boolean;
    @Input() isUpdateButtonVisible: boolean;
    @Input() isResetButtonVisible: boolean;
    @Output() onClearAll = new EventEmitter<void>();
    @Output() onSaveCurrentFilter = new EventEmitter<void>();
    @Output() onResetCurrentFilter = new EventEmitter<void>();

    constructor(private appTextService: AppTextService) {}

    getSaveFilterLabel(): string {
        return this.appTextService.get(this.currentFilterId ? 'filter.update_filter' : 'save_filter');
    }

    clearAll() {
        this.onClearAll.emit();
    }

    saveCurrentFilter() {
        this.onSaveCurrentFilter.emit();
    }

    resetCurrentFilter() {
        this.onResetCurrentFilter.emit();
    }
}
